<template>
  <smd-one-col-layout class="modal-add-prescription"
                      :content-styles="computedContentStylesClass">
    <smd-header class="top-bar-box-shadow" slot="header" nav>
      <span class="ns-icon-ico028"
            slot="left-actions"
            @click="goBack"/>
      <text-string class="gray-400"
                   :label-id="$isDesktop ? 'txt071__desktop' : 'txt071'"/>
      <span class="ns-icon-ico001"
            slot="right-actions"
            v-if="$isMobile">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <div class="smd-form__row">
      <smd-list-selection-panel :has-text-string="true"
                                @selected="addPrescriptionFile">
        <text-string slot="placeholder"
                     :label-id="$isDesktop ? 'txt215__desktop' : 'txt215'"/>
        <span class="ns-icon-ico020 ns-large-icon" slot="icon">
          <span class="path1"></span>
          <span class="path2"></span>
        </span>
      </smd-list-selection-panel>
    </div>

    <div class="smd-form__row justify-content-center">
      <smd-or-divider/>
    </div>

    <template v-if="filteredAvailablePrescriptionList.length">
      <file-pres-add v-for="(item, index) in filteredAvailablePrescriptionList"
                     :item="item"
                     :key="index"
                     :hide-coupon="!isIssuedCoupon(item) || computedHideCoupon(item)"
                     @add="addPrescriptionFn(item)"
                     @view="previewFile(item, $options.PreviewType.PREVIEW_TYPE_PRESCRIPTION)"/>

      <!-- :disabled-add="computedDisabledAdd(item)"-->
    </template>

    <empty-state type="prescription" v-else/>

    <!--  hidden input for adding prescription  -->
    <input class="input-hidden"
           ref="prescription-input"
           type="file"
           @change="handlePrescriptionFileSelection"/>
  </smd-one-col-layout>
</template>

<script>
  import {mapFields} from "vuex-map-fields";
  import {mapActions, mapGetters, mapMutations} from "vuex";
  import {formatDate} from '@/utils/dates';

  import Routes from "@/router/routes";

  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import EmptyState from '@/components/empty-state';
  import FilePresAdd from '@/components/file/file-pres-add';
  import ModalPreviewFile from '@/modals/modal-preview-file';
  import PreviewType from '@/reference/preview-file-type';
  import TitleMixin from "@/mixins/title-mixin";

  import {
    GETTER_FILES,
    ACTION_EDIT_ACCOUNT,
    MUTATE_ADD_ATTACHED_PRESCRIPTION,
  } from "@/store/types";

  import {
    isCouponExpired,
    getPrescriptionCoupon,
  } from '@/utils/medicine';
  import moment from "moment";

  export default {
    name: "add-prescription",
    mixins: [TitleMixin, CloseModalMixin],
    components: {FilePresAdd, EmptyState},
    props: {
      title: {default: ''},
    },
    data() {
      return {
        error: null,
      };
    },
    computed: {
      ...mapFields({
        prescriptionFileView: 'prescriptionFileView',
        prescriptionView: 'prescriptionView',
        attachedPrescriptions: 'attachedPrescriptions',
      }),
      ...mapGetters({
        files: GETTER_FILES,
      }),
      computedContentStylesClass() {
        return [{'dark-light-bg': !this.$isMobile}, 'modal-add-prescription__content-style']
      },
      prescriptionInput() {
        return this.$refs['prescription-input']
      },
      prescriptionList() {
        return this.files.filter(file => file.pagetype === 'prescription' || file.pagetype === 'image' || file.pagetype === 'customform');
      },
      filteredAvailablePrescriptionList() {
        let availablePrescriptions = this.prescriptionList.filter(pres => {
          return this.attachedPrescriptions.length ? !this.attachedPrescriptions.some(apres => pres.uploadid === apres.uploadid) : true
        })

        return availablePrescriptions.slice(0).sort((a, b) => moment(b.received).valueOf() - moment(a.received).valueOf());
      },
    },
    methods: {
      ...mapActions({
        editAccount: ACTION_EDIT_ACCOUNT,
      }),
      ...mapMutations({
        addPrescription: MUTATE_ADD_ATTACHED_PRESCRIPTION
      }),
      addPrescriptionFn(item) {
        this.prescriptionView = item;

        const coupon = getPrescriptionCoupon(item);
        const prescription = {
          ...item,
          partial: false,
          remarks: '',
        };

        if (coupon) {
          prescription.includeOtherItems = true;
        }

        this.addPrescription(prescription);
        this.$router.push({name: Routes.PHARMACY_ORDERS});
      },
      addPrescriptionFile() {
        this.prescriptionInput.value = null;
        this.prescriptionInput.click();
      },
      computedDisabledAdd(item) {
        return item.coupons ? !!(item.coupons.length && !!(this.attachedPrescriptions.length) && !this.computedHideCoupon(item) && this.isIssuedCoupon(item)) : false;
      },
      computedHideCoupon(item) {
        return item.coupons && item.coupons[0] ? isCouponExpired(item.coupons[0]) : true;
      },
      goBack() {
        this.$goBack();
      },
      handlePrescriptionFileSelection() {
        const [file] = this.prescriptionInput.files;

        // some WebViews fire change with an empty FileList on cancel; the preview
        // modal reads file.type, so opening it without a file throws
        if (!file) {
          return;
        }

        this.prescriptionFileView = file;

        // this.previewFile(this.prescriptionFileView, PreviewType.PREVIEW_TYPE_PRESCRIPTION_FILE);
        this.$modal.open({
          component: ModalPreviewFile,
          props: {
            file: [this.prescriptionFileView],
            title: this.computedTitle(this.prescriptionFileView),
            type: PreviewType.PREVIEW_TYPE_PRESCRIPTION_FILE
          },
          onClose: ({success}) => {
            if (success) {
              this.goBack();
            }
          }
        })
      },
      isIssuedCoupon(item) {
        const possibleValues = ['issued', 'availed'];
        return possibleValues.includes(item.coupons ? item.coupons.length ? item.coupons[0].status.toLowerCase() : '' : '');
      },
      previewFile(item, type) {
        if (!this.computedDisabledAdd(item)) {
          this.$router.push({
            name: Routes.PHARMACY_PREVIEW_FILE,
            params: {
              file: [item],
              title: this.computedTitle(item),
              type: type
            },
          })
        }
      },
    },
    filters: {
      displayDateString(isoDate) {
        const date = formatDate(isoDate, 'MMM DD, YYYY');
        const time = formatDate(isoDate, 'h:mm A');
        return `Sent on ${date} at ${time}`
      },
    },
    PreviewType
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";


  .modal-add-prescription__content-style {
    > div {
      @include set-max-width($max-width: 1583px);
    }

    @include responsive('min-width: 1024px') {
      padding: space(xl) !important;
    }
  }
</style>